import React from 'react';
import VehiclePassportOwnerPanel from './VehiclePassportOwnerPanel';

type Props = {
  vehicleId: number;
  subjectLabel?: string | null;
};

/**
 * Share modal → QR & sticker.
 * One build code: Passport vinyl is the print surface; encounter settings live here too.
 */
const VehicleShareQrPanel: React.FC<Props> = ({ vehicleId, subjectLabel }) => {
  return (
    <div className="space-y-2">
      <VehiclePassportOwnerPanel
        vehicleId={vehicleId}
        subjectLabel={subjectLabel}
        isOwner
        embedded
        shareSurface
      />
    </div>
  );
};

export default VehicleShareQrPanel;
